module.exports = __webpack_public_path__ + "public/img/ico-schematics-battery-shadow.e5ede18b.svg";